import React from 'react';

import AMWithoutRegions from './TablesForArbitrationManagersSection/AMWithoutRegions';
import AMWithRegions from './TablesForArbitrationManagersSection/AMWithRegions';

const ArbitrationManagersTable = () => {
    const [onReloadTable, setOnReloadTable] = React.useState(false);

    return (
      <div className='pageWrapper'>
        <AMWithoutRegions onReloadTable={onReloadTable} setOnReloadTable={setOnReloadTable} />
        <AMWithRegions onReloadTable={onReloadTable} setOnReloadTable={setOnReloadTable} />
      </div>
    )
}

export default ArbitrationManagersTable;